import moment from 'moment/moment'
import IndexController from '../index_controller'

export default class extends IndexController {
  connect () {
    super.connect()

    $('#logs').dropdown({})
    $('#report-templates').dropdown({})

    super.initializeFromToDateFilters()
  }

  buildFilters () {
    const filters = super.buildFilters()
    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].logs = $('#logs').dropdown('get values') || []
    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].report_templates = $('#report-templates').dropdown('get values') || []

    const fromDate = moment.utc($('#from-date-filter').data('datepicker').getDate())
    const toDate = moment.utc($('#to-date-filter').data('datepicker').getDate()).add(1, 'd').subtract(1, 's')

    if (fromDate && fromDate.isValid()) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].from_date = fromDate.unix()
    }

    if (toDate && toDate.isValid()) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].to_date = toDate.unix()
    }

    return filters
  }

  setUIFilterDefaults () {
    this.disableFilterEvents()
    $('#logs').dropdown('clear')
    $('#report-templates').dropdown('clear')
    $('#reports-search-input').val('')
    $('#from-date-filter').datepicker('clearDates')
    $('#to-date-filter').datepicker('clearDates')
    this.enableFilterEvents()
  }
}
